import { Commit } from 'vuex'
import { RootGetterNames, RootMutationNames } from '@/store'

interface CallApiWithoutDuplicateDto {
  commit: Commit
  rootGetters: any
  actionName: string
  params: Record<string, any> | null
  fn: () => Promise<void>
}

export async function callApiWithoutDuplicate({
  commit,
  rootGetters,
  actionName,
  params,
  fn,
}: CallApiWithoutDuplicateDto): Promise<void> {
  const name = `${actionName}${params ? '_' + JSON.stringify(params) : ''}`
  if (rootGetters[RootGetterNames.GetApiCall](name)) {
    console.info('avoided duplicate api call:', name)
    return
  }

  commit(RootMutationNames.AddApiCall, name, { root: true })
  await fn()
  commit(RootMutationNames.RemoveApiCall, name, { root: true })
}

export function addOrUpdateSameKeyObjectInArray<T>(list: T[], object: T, key = 'id'): T[] {
  const clonedList = [...list]
  const sameIdIndex = clonedList.findIndex(item => item[key] === object[key])
  if (sameIdIndex >= 0) {
    clonedList.splice(sameIdIndex, 1, object)
  } else {
    clonedList.push(object)
  }
  return clonedList
}
